import Videos from '../videos/Videos';
import Slider from '../slider/Slider';

const HomePageMembers = () => {
  return (
    <div>
      <Slider />
      <Videos />
    </div>
  );
};

export default HomePageMembers;
